import ServiceGraphQL from 'src/service/gql-service';
import { removePaymentMethod } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const RemovePaymentMethod = (_id) => {
  const params = {
    query: removePaymentMethod.QUERY,
    variables: {
      filter: {
        _id
      }
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
